import React from 'react'
import { AGILE_COURSE_PAGE_2, AGILE_DETAILS_PAGE_2, AGILE_HERO_PAGE_2, BANKING_BOTTOM_CONTENT } from '../../../utils/constants'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import { AGILE_ACCORDIAN_2 } from '../../../utils/courseConifg'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'

const AgilePage_2 = () => {
  return (
    <div className='outlet-render'>
    <CourseAsideHero  {...AGILE_HERO_PAGE_2}/>
     <CoursesAside {...AGILE_COURSE_PAGE_2}/>
     <CourseCard {...AGILE_DETAILS_PAGE_2}/>
     <Accordian {...AGILE_ACCORDIAN_2}/>
     <PageDesc {...BANKING_BOTTOM_CONTENT}/>
   </div>
  )
}

export default AgilePage_2